module.exports = __webpack_public_path__ + "img/button_chat_icon.4386db8a.svg";